import axios from "axios";
import { Auth } from "aws-amplify";
// import FormData from 'form-data';
import { APIS, isEmpty } from "./constants";

const commonHeader = {
  "Content-Type": "application/json",
};

export async function getAccessToken() {
  try {
    const session = await Auth.currentSession();
    const accessToken = session.getAccessToken().getJwtToken();
    const idToken = session.getIdToken().getJwtToken();
    localStorage.setItem("idToken", idToken);
    localStorage.setItem("accessToken", accessToken);
    return idToken;
  } catch (error) {
    console.error("Error getting access token:", error);
    return '';
  }
}

// async function checkIsAuthorized() {
//   try {
//     const session = await Auth.currentAuthenticatedUser();
//     const accessTokenExpiration = new Date(session.getIdToken().getExpiration() * 1000).getTime();
//     const currentTime = new Date().getTime();
//     if (accessTokenExpiration < currentTime) {
//       await Auth.signOut();
//       localStorage.clear();
//       window.location.reload();
//       console.log('User logged out due to expired token.');
//       return false;
//     }
//     console.log('User is signed in.');
//     return true;
//   } catch (error) {
//     console.error('Error checking authorization:', error);
//     await Auth.signOut();
//     localStorage.clear();
//     window.location.reload();
//     return false;
//   }
// }

async function call(options) {
  try {
    const token = await getAccessToken();
    const response = await axios({ ...options, headers: { ...options.headers, Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error('Error making API call:', error);
    // await checkIsAuthorized();
    throw error;
  }
}

export async function fetcherPost(url, data) {
  return call({ url, method: "POST", data, headers: commonHeader });
}

export async function fetcherPut(url, data) {
  return call({ url, method: "PUT", data, headers: commonHeader });
}

export async function fetcherPatch(url, data) {
  return call({ url, method: "PATCH", data, headers: commonHeader });
}

export async function fetcherDelete(url, data) {
  return call({ url, method: "DELETE", data, headers: commonHeader });
}

export async function fetcherGet(url, params) {
  return call({ url, method: "GET", params, headers: commonHeader });
}

export const handleProfileUpload = async (file, isStudent, userId) => {
  try {
    if (!isStudent) {
      const token = await getAccessToken();
      var data = new FormData();
          data.append('file', file);

      var config = {
        method: 'post',
        url: !isEmpty(userId) ? `${APIS.MENTOR_UPLOAD_PROFILE}?user_id=${userId}` : `${APIS.MENTOR_UPLOAD_PROFILE}`,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
        data: data
      };

      axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
    } else {
      const token = await getAccessToken();
      const formData = new FormData();
      formData.append('form', file);
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': isStudent ? 'application/json' : 'multipart/form-data',
      };
      let url = !isEmpty(userId) ? `${APIS.UPLOAD_PROFILE}?user_id=${userId}` : `${APIS.UPLOAD_PROFILE}`;
      return await axios.put(url, formData, { headers });
    }
  } catch (error) {
    console.error('Error uploading profile:', error);
    throw error;
  }
};
